export default __webpack_public_path__ + "static/background-min-aa8d3cb60122caa5f81596588410bb37.png";